import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import ActionUpdateRegistry from "../../components/action/ActionUpdateRegistry";
import AgencyAction from "../../components/action/AgencyAction";
import ButtonAdd from "../../components/main/ButtonAdd";


export const HeaderCategory = [
    {
        Header: "Nome categoria",
        accessor: "nome",
        disableSortBy: true,
        Filter: false,
        customSort: false
    },
    {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Filter: false,
        customSort: false,
        Cell: ({ row }: any) => (
            <div className="flex space-x-4 justify-end items-center px-5">
                <AgencyAction type="updateCategory" icon={<PencilSquareIcon className="w-6 h-6" />} idAzienda={row.original.aziendaId} infoForm={row.original} />
                <AgencyAction type="deleteCategory" icon={<TrashIcon className="w-5 h-5" />} idAzienda={row.original.aziendaId} infoForm={row.original} />
            </div>
        )
    }
]